/*function stopVibrations() {
    navigator.vibrate(0);
}

function ResetInitiativeAlerts() {
    navigator.vibrate([50, 50, 50, 30000, 75, 75, 75, 30000, 100, 100, 100, 30000, 150, 150, 150]);
}*/

const INITIATIVE_DEBOUNCE_MS = 400;

function GetInitiativeElement(nameSluggified: string): HTMLInputElement {
    return ById<HTMLInputElement>("initiative-" + nameSluggified);
}

// An empty field and a zero mean different things everywhere except in the initiative, where the server has
// no null to store "not picked yet" in and uses 0 for it.
function InitiativeText(value: number): string {
    return value ? String(value) : "";
}

// The field follows the server in both directions, because the lock can come from somewhere other than your
// own tap - dying pins the initiative from whoever hit the skull, a new round releases everyone. The focus
// check is not the same thing as the write gate: a state can be perfectly up to date and still have no
// business landing in a field you are typing in.
function ResetInitiativeLock(participant: Participant): void {
    const nameSluggified = participant.nameSluggified;
    const initiativeSelectionElement = TryById<HTMLElement>("initiativeSelection-" + nameSluggified);
    if (!initiativeSelectionElement)
        return;

    initiativeSelectionElement.style.display = participant.initiativeLocked ? "none" : "";

    const initiativeField = GetInitiativeElement(nameSluggified);
    if (document.activeElement !== initiativeField) {
        initiativeField.value = InitiativeText(participant.initiative);
    }

    updateInitiativeInfoVisibility();
}

// Typing "42" is two keystrokes and used to be two posts, the first of them announcing an initiative of 4
// to the whole table.
function QueueCallInitiative(nameSluggified: string): void {
    HoldWrite(InitiativeValueKey(nameSluggified));

    Debounce(InitiativeValueKey(nameSluggified), INITIATIVE_DEBOUNCE_MS, () => CallInitiative(nameSluggified));
}

function CallInitiative(nameSluggified: string): void {
    //stopVibrations();
    const initiativeElement = GetInitiativeElement(nameSluggified);
    CancelDebounce(InitiativeValueKey(nameSluggified));

    PostRoundWrite(InitiativeValueKey(nameSluggified), "/Participant/CallInitiative", {
        slugName: nameSluggified,
        initiative: initiativeElement.value,
        roomKey: RoomKey()
    });
}

function LockInitiative(nameSluggified: string): void {
    //stopVibrations();
    const initiativeElement = GetInitiativeElement(nameSluggified);
    if (!initiativeElement.value) {
        alert("Je initiative is leeg megool");
        return;
    }

    const initiativeSelectionElement = ById<HTMLElement>("initiativeSelection-" + nameSluggified);
    initiativeSelectionElement.style.display = "none";

    // The lock carries the number itself, so a debounced value write is cancelled and its hold released by
    // hand. The lock takes its own hold first: dropping to nothing outstanding, even for one statement,
    // would let a waiting state through, and that state is one where you have not locked yet.
    HoldWrite(InitiativeLockKey(nameSluggified));
    CancelDebounce(InitiativeValueKey(nameSluggified));
    ReleaseWrite(InitiativeValueKey(nameSluggified), null);

    PostRoundWrite(InitiativeLockKey(nameSluggified), "/Participant/LockInitiative", {
        slugName: nameSluggified,
        initiative: initiativeElement.value,
        roomKey: RoomKey()
    });
}

function ShortRest(nameSluggified: string): void {
    PostRoundWrite("condition:" + nameSluggified, "/Participant/AddCondition", {
        slugName: nameSluggified,
        conditionAsString: ConditionType.ShortRest,
        roomKey: RoomKey()
    });
}

function LongRest(nameSluggified: string): void {
    const initiativeElement = GetInitiativeElement(nameSluggified);
    const initiativeSelectionElement = ById<HTMLElement>("initiativeSelection-" + nameSluggified);

    initiativeElement.value = String(MaxInitiative);

    CallInitiative(nameSluggified);

    PostRoundWrite("condition:" + nameSluggified, "/Participant/AddCondition", {
        slugName: nameSluggified,
        conditionAsString: ConditionType.LongRest,
        roomKey: RoomKey()
    });

    initiativeSelectionElement.style.display = "none";

    PostRoundWrite(InitiativeLockKey(nameSluggified), "/Participant/LockInitiative", {
        slugName: nameSluggified,
        initiative: MaxInitiative,
        roomKey: RoomKey()
    });
}

function RemoveMember(nameSluggified: string): void {
    const initiativeSelectionElement = TryById<HTMLElement>("initiativeSelection-" + nameSluggified);
    if (initiativeSelectionElement) {
        initiativeSelectionElement.remove();
        updateInitiativeInfoVisibility();
    }

    PostRoundWrite("member:" + nameSluggified, "/Participant/RemoveMember", {
        slugName: nameSluggified,
        roomKey: RoomKey()
    });
}

function ResetContextInitiative(): void {
    const nameSluggified = localStorage.getItem("nameSluggified");
    if (!nameSluggified) {
        return;
    }

    HoldWrite(InitiativeLockKey(nameSluggified));
    CancelDebounce(InitiativeValueKey(nameSluggified));
    ReleaseWrite(InitiativeValueKey(nameSluggified), null);

    PostRoundWrite(InitiativeLockKey(nameSluggified), "/Participant/ResetInitiative", {
        slugName: nameSluggified,
        roomKey: RoomKey()
    });

    CloseAllPopups();
}

function RemoveParticipant(): void {
    const nameSluggified = localStorage.getItem("nameSluggified");
    if (!nameSluggified) {
        return;
    }

    if (confirm("Are you sure you want to remove this participant?")) {
        RemoveMember(nameSluggified);
        ById<HTMLElement>("applyConditionDropdown").classList.remove("show");
    }
}

function AddInitiativeSelection(nameSluggified: string, name: string | null, role?: Role): void {
    const initiativeSelection = document.createElement('div');
    initiativeSelection.id = "initiativeSelection-" + nameSluggified;
    initiativeSelection.className = "initiative-selection";

    // Left group: initiative field and lock button
    const initiativeGroup = document.createElement('div');
    initiativeGroup.className = "initiative-group";

    const initiativeField = document.createElement('input');
    initiativeField.id = "initiative-" + nameSluggified;
    initiativeField.type = "number";
    initiativeField.className = "initiative-field";

    initiativeField.onkeyup = () => QueueCallInitiative(nameSluggified);
    if (name) { //if is monster in feite
        initiativeField.placeholder = name;

        const removeMemberButton = document.createElement('input');
        removeMemberButton.type = "button";
        removeMemberButton.value = "🗑";
        removeMemberButton.className = "remove-member-button";
        removeMemberButton.onclick = () => RemoveMember(nameSluggified);
        initiativeGroup.append(removeMemberButton);
    }
    initiativeGroup.append(initiativeField);

    const initiativeButton = document.createElement('input');
    initiativeButton.type = "button";
    initiativeButton.value = "🔒";
    initiativeButton.className = "lock-nisjetif-button";
    initiativeButton.onclick = () => LockInitiative(nameSluggified);
    initiativeGroup.append(initiativeButton);

    initiativeSelection.append(initiativeGroup);

    // Right group: rest buttons (only for players, not monsters, DungeonMaster, or Spectator)
    const isPlayer = !name && role !== Role.DungeonMaster && role !== Role.Spectator && role !== Role.Monster;
    if (isPlayer) {
        const restGroup = document.createElement('div');
        restGroup.className = "rest-group";

        const shortRestButton = document.createElement('button');
        shortRestButton.className = "rest-button";
        shortRestButton.onclick = () => ShortRest(nameSluggified);

        const shortRestImg = document.createElement('img');
        shortRestImg.src = "/status-icons/ShortRest.png";
        shortRestImg.className = "rest-icon";
        shortRestButton.append(shortRestImg);
        restGroup.append(shortRestButton);

        const longRestButton = document.createElement('button');
        longRestButton.className = "rest-button";
        longRestButton.onclick = () => LongRest(nameSluggified);

        const longRestImg = document.createElement('img');
        longRestImg.src = "/status-icons/LongRest.png";
        longRestImg.className = "rest-icon";
        longRestButton.append(longRestImg);
        restGroup.append(longRestButton);

        initiativeSelection.append(restGroup);
    }

    const initiativeInfoElement = ById<HTMLElement>("initiativeInfo");
    initiativeInfoElement.append(initiativeSelection);
    initiativeInfoElement.style.display = "block";
}

function updateInitiativeInfoVisibility(): void {
    const initiativeInfoElement = TryById<HTMLElement>("initiativeInfo");
    if (!initiativeInfoElement) {
        return;
    }

    // Check if there are any visible children
    let hasVisibleChildren = false;
    for (let i = 0; i < initiativeInfoElement.children.length; i++) {
        const child = initiativeInfoElement.children[i] as HTMLElement;
        if (child.style.display !== "none" && window.getComputedStyle(child).display !== "none") {
            hasVisibleChildren = true;
            break;
        }
    }

    if (hasVisibleChildren) {
        initiativeInfoElement.style.display = "block";
    } else {
        initiativeInfoElement.style.display = "none";
    }
}
